import React, { useState } from 'react';
import { PrivacyModal } from '../ui/PrivacyModal';
export function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <footer className="py-8 px-4 bg-[var(--bg-deepest)] border-t border-[var(--bg-card-hover)]" data-id="element-25">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-[var(--text-muted)]" data-id="element-26">
          <p data-id="element-27">
            © {new Date().getFullYear()} 3AM Club. Todos los derechos
            reservados.
          </p>

          <button onClick={() => setIsModalOpen(true)} className="hover:text-[var(--accent-amber)] transition-colors underline decoration-transparent hover:decoration-[var(--accent-amber)] underline-offset-4" data-id="element-28">
            Política de Privacidad
          </button>
        </div>
      </footer>

      <PrivacyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-29" />
    </>;
}